import type { ConfigType } from '@plone/registry';

import BlogFolderView from '../components/views/BlogFolderView';
import BlogItemView from '../components/views/BlogItemView';
import EspecialitatsItemView from '../components/views/EspecialitatsItemView';
import EspecialitatsFolderView from '../components/views/EspecialitatsFolderView';
import HomePageBlocksView from '../components/views/HomePageBlocksView';
import LanguageRootHomeView from '../components/views/LanguageRootHomeView';
import MetgeView from '../components/views/MetgeView';
import NewsFolderView from '../components/views/NewsFolderView';
import NewsItemView from '../components/views/NewsItemView';
import QuadreMedicPage from '../components/views/QuadreMedicPage';
import UnitatsEspecialitzadesFolder from '../components/views/UnitatsEspecialitzadesFolder';
import UnitatEspecialitzadaView from '../components/views/UnitatEspecialitzadaView';

import {
  especialitatsFolderContentIds,
  newsFolderContentIds,
  quadreMedicFolderContentIds,
  unitatsEspecialitzadesFolderContentIds,
} from '../helpers/localizedSectionPath';

export default function installViews(config: ConfigType) {
  config.views.contentTypesViews = {
    ...config.views.contentTypesViews,
    LRF: LanguageRootHomeView,
    pagina_inicial: HomePageBlocksView,
    entrada_del_blog: BlogItemView,
    noticia: NewsItemView,
    NewsItem: NewsItemView,
    csjespecialitats: EspecialitatsItemView,
    csjmetges: MetgeView,
    unitatespecialitzada: UnitatEspecialitzadaView,
  };

  const quadreMedicViews = Object.fromEntries(
    quadreMedicFolderContentIds().map((id) => [id, QuadreMedicPage]),
  );

  config.settings.contentIdViews = {
    ...(config.settings.contentIdViews || {}),
    ...quadreMedicViews,
  };

  const newsFolderViews = Object.fromEntries(
    newsFolderContentIds().map((id) => [id, NewsFolderView]),
  );

  const especialitatsFolderViews = Object.fromEntries(
    especialitatsFolderContentIds().map((id) => [id, EspecialitatsFolderView]),
  );

  const unitatsFolderViews = Object.fromEntries(
    unitatsEspecialitzadesFolderContentIds().map((id) => [
      id,
      UnitatsEspecialitzadesFolder,
    ]),
  );

  config.settings.contentFolderViews = {
    ...(config.settings.contentFolderViews || {}),
    ...newsFolderViews,
    ...especialitatsFolderViews,
    ...unitatsFolderViews,
    blog: BlogFolderView,
  };

  return config;
}
